var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeaderLogo = function SvgHeaderLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 147.52,
    height: 140.853,
    viewBox: "0 0 366.48 140.853",
    preserveAspectRatio: "xMinYMin meet",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "header-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2749v1056H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "header-logo_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1298.16 1056.43 0 0h722.941l575.219 1056.43z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M1018.59 900.797h203.29L886.52 280.563 694.879 637.934l323.711 262.863",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 140.853)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m982.367 102.137 428.573 798.14h-194.77l-333.057-613.32 99.254-184.82",
    style: {
      fill: "#59c134",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 140.853)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m909.137 239.414 355.353 660.863h-51.31L880.852 291.16l28.285-51.746",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 140.853)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.32 900.277H553.801l145.816-271.152 331.703 271.152",
    style: {
      fill: "#59c134",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 140.853)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#header-logo_svg__a)",
    transform: "matrix(.13333 0 0 -.13333 0 140.853)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#header-logo_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-34.258 3.852h822.446V-20.43H-34.258V3.852",
    style: {
      fill: "#d3e0f4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29.852 8.98H792.59v-24.289H-29.852v24.29",
    style: {
      fill: "#d2dff4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.465 14.121h822.442v-24.3H-25.465v24.3",
    style: {
      fill: "#d1dff4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21.063 19.262H801.38V-5.04H-21.063v24.3",
    style: {
      fill: "#d0def3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.664 24.379H805.78V.109H-16.664v24.27",
    style: {
      fill: "#cfddf3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.273 29.52h822.445V5.219H-12.273v24.3",
    style: {
      fill: "#ceddf3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.871 34.66H814.57v-24.3H-7.871v24.3",
    style: {
      fill: "#cddcf3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.473 39.781H818.97V15.5H-3.473v24.281",
    style: {
      fill: "#ccdbf2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.918 44.91h822.449V20.63H.918V44.91",
    style: {
      fill: "#cbdbf2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.316 50.059h822.45V25.75H5.316v24.309",
    style: {
      fill: "#cadaf2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.719 55.2h822.445V30.897H9.719V55.2",
    style: {
      fill: "#c9d9f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.121 60.313h822.442V36.03H14.121v24.282",
    style: {
      fill: "#c8d9f1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.512 65.45H840.96V41.147H18.511V65.45",
    style: {
      fill: "#c7d8f1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.91 70.594h822.442V46.289H22.91v24.305",
    style: {
      fill: "#c6d7f1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.309 75.715h822.449V51.44H27.308v24.274",
    style: {
      fill: "#c5d7f1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7 80.848h822.445V56.55H31.699v24.297",
    style: {
      fill: "#c4d6f1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.105 85.984h822.442V61.688H36.105v24.296",
    style: {
      fill: "#c3d5f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.504 91.121h822.441V66.824H40.504v24.297",
    style: {
      fill: "#c2d5f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.902 96.25h822.442V71.965H44.902V96.25",
    style: {
      fill: "#c1d4f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.293 101.387h822.445V77.09H49.293v24.297",
    style: {
      fill: "#c0d4f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.695 106.523h822.442V82.227H53.695v24.296",
    style: {
      fill: "#c0d3ef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.098 111.641h822.437V87.363H58.098v24.278",
    style: {
      fill: "#bfd2ef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.496 116.785h822.442V92.481H62.496v24.304",
    style: {
      fill: "#bdd2ef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.887 121.926h822.437V97.625H66.887v24.301",
    style: {
      fill: "#bdd1ef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.285 127.059H893.73v-24.297H71.285v24.297",
    style: {
      fill: "#bcd0ee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.68 132.176h822.449v-24.278H75.679v24.278",
    style: {
      fill: "#bbd0ee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.078 137.313H902.52v-24.297H80.078v24.297",
    style: {
      fill: "#bacfee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.477 142.461h822.441v-24.309H84.477v24.309",
    style: {
      fill: "#b9ceee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.879 147.578h822.445v-24.277H88.879v24.277",
    style: {
      fill: "#b8ceed",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.266 152.715h822.457v-24.297H93.266v24.297",
    style: {
      fill: "#b7cded",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.672 157.852h822.441v-24.297H97.672v24.297",
    style: {
      fill: "#b6cded",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.07 162.988h822.442v-24.297H102.07v24.297",
    style: {
      fill: "#b5cced",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.469 168.113h822.449v-24.285H106.469v24.285",
    style: {
      fill: "#b4cbec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.859 173.25h822.446v-24.297H110.859v24.297",
    style: {
      fill: "#b3cbec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.266 178.387h822.437v-24.293H115.266v24.293",
    style: {
      fill: "#b2caec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.664 183.508h822.441v-24.281H119.664v24.281",
    style: {
      fill: "#b1c9ec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.055 188.641h822.449v-24.278H124.055v24.278",
    style: {
      fill: "#b0c9ec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.453 193.789h822.445V169.48H128.453v24.309",
    style: {
      fill: "#afc8eb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.852 198.926h822.445v-24.297H132.852v24.297",
    style: {
      fill: "#aec8eb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.258 204.043h822.437v-24.277H137.258v24.277",
    style: {
      fill: "#adc7eb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.645 209.18h822.441v-24.297H141.645v24.297",
    style: {
      fill: "#acc6eb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.047 214.324h822.437V190.02H146.047v24.304",
    style: {
      fill: "#abc6ea",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.445 219.441h822.446v-24.277H150.445v24.277",
    style: {
      fill: "#aac5ea",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.836 224.578h822.453v-24.277H154.836v24.277",
    style: {
      fill: "#a9c5ea",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.238 229.719H981.68v-24.297H159.238v24.297",
    style: {
      fill: "#a8c4ea",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.637 234.852h822.441v-24.297H163.637v24.297",
    style: {
      fill: "#a7c3e9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.035 239.98H990.48v-24.289H168.035v24.289",
    style: {
      fill: "#a6c3e9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.426 245.117h822.445V220.82H172.426v24.297",
    style: {
      fill: "#a5c2e9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.824 250.254h822.449v-24.297H176.824v24.297",
    style: {
      fill: "#a4c2e9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.238 255.395h822.442v-24.282H181.238v24.282",
    style: {
      fill: "#a4c1e9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.641 260.531h822.439V236.23H185.641v24.301",
    style: {
      fill: "#a3c0e8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.039 265.676h822.441v-24.301H190.039v24.301",
    style: {
      fill: "#a2c0e8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.43 270.789h822.45v-24.277H194.43v24.277",
    style: {
      fill: "#a1bfe8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.828 275.926h822.442v-24.278H198.828v24.278",
    style: {
      fill: "#a0bfe8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.234 281.07h822.436v-24.304H203.234v24.304",
    style: {
      fill: "#9fbee7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.621 286.207h822.449V261.91H207.621v24.297",
    style: {
      fill: "#9ebde7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.023 291.328h822.437v-24.281H212.023v24.281",
    style: {
      fill: "#9dbde7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.422 296.465h822.448v-24.297H216.422v24.297",
    style: {
      fill: "#9cbce7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.824 301.602h822.446v-24.297H220.824v24.297",
    style: {
      fill: "#9bbce6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.215 306.723h822.455v-24.282H225.215v24.282",
    style: {
      fill: "#9abbe6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.613 311.859h822.447v-24.296H229.613v24.296",
    style: {
      fill: "#99bbe6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.016 317h822.444v-24.301H234.016V317",
    style: {
      fill: "#98bae6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.402 322.137h822.458v-24.293H238.402v24.293",
    style: {
      fill: "#97b9e6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.809 327.262h822.441v-24.285H242.809v24.285",
    style: {
      fill: "#96b9e5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.207 332.398h822.443v-24.296H247.207v24.296",
    style: {
      fill: "#95b8e5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.598 337.539h822.452v-24.301H251.598v24.301",
    style: {
      fill: "#94b8e5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.996 342.656h822.444v-24.277H255.996v24.277",
    style: {
      fill: "#93b7e5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.395 347.793h822.445v-24.297H260.395v24.297",
    style: {
      fill: "#93b7e4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.801 352.934h822.439v-24.301H264.801v24.301",
    style: {
      fill: "#92b6e4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.191 358.051h822.439v-24.278H269.191v24.278",
    style: {
      fill: "#91b5e4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.59 363.191h822.46V338.91H273.59v24.281",
    style: {
      fill: "#90b5e4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.988 368.328h822.442v-24.297H277.988v24.297",
    style: {
      fill: "#8fb4e4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.395 373.469h822.435v-24.297H282.395v24.297",
    style: {
      fill: "#8eb4e3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.781 378.59h822.439v-24.285H286.781v24.285",
    style: {
      fill: "#8db3e3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.184 383.727h822.436V359.43H291.184v24.297",
    style: {
      fill: "#8cb3e3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.582 388.867h822.448v-24.301H295.582v24.301",
    style: {
      fill: "#8bb2e3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.973 394.004h822.457v-24.297H299.973v24.297",
    style: {
      fill: "#8ab2e2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.375 399.121h822.445v-24.277H304.375v24.277",
    style: {
      fill: "#89b1e2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.773 404.262h822.447v-24.297H308.773v24.297",
    style: {
      fill: "#88b1e2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.176 409.402h822.444v-24.3H313.176v24.3",
    style: {
      fill: "#87b0e2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.563 414.52h822.447v-24.278H317.563v24.278",
    style: {
      fill: "#86afe2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.965 419.656h822.445v-24.273H321.965v24.273",
    style: {
      fill: "#86afe1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.367 424.801h822.443v-24.305H326.367v24.305",
    style: {
      fill: "#85aee1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.758 429.938h822.452v-24.297H330.758v24.297",
    style: {
      fill: "#84aee1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.156 435.059H1157.6v-24.282H335.156v24.282",
    style: {
      fill: "#83ade1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.555 440.195H1162v-24.297H339.555v24.297",
    style: {
      fill: "#82ade0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.945 445.332H1166.4v-24.297H343.945v24.297",
    style: {
      fill: "#81ace0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.352 450.453h822.438v-24.281H348.352v24.281",
    style: {
      fill: "#80ace0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.75 455.59h822.44v-24.297H352.75v24.297",
    style: {
      fill: "#7fabe0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.148 460.73h822.442v-24.3H357.148v24.3",
    style: {
      fill: "#7eabe0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.539 465.867h822.451V441.57H361.539v24.297",
    style: {
      fill: "#7daadf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.938 470.984h822.442v-24.277H365.938v24.277",
    style: {
      fill: "#7caadf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.344 476.129h822.436v-24.297H370.344v24.297",
    style: {
      fill: "#7ca9df",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.742 481.27h822.438v-24.301H374.742v24.301",
    style: {
      fill: "#7ba9df",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.133 486.387h822.437v-24.278H379.133v24.278",
    style: {
      fill: "#7aa8de",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.531 491.523h822.449v-24.296H383.531v24.296",
    style: {
      fill: "#79a8de",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.93 496.664h822.45v-24.301H387.93v24.301",
    style: {
      fill: "#78a7de",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.324 501.781h822.456v-24.277H392.324v24.277",
    style: {
      fill: "#77a7de",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.723 506.926h822.447v-24.285H396.723v24.285",
    style: {
      fill: "#76a6de",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.121 512.059h822.439v-24.297H401.121v24.297",
    style: {
      fill: "#75a6dd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.512 517.195h822.458v-24.297H405.512v24.297",
    style: {
      fill: "#74a5dd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.91 522.32h822.46v-24.285H409.91v24.285",
    style: {
      fill: "#73a5dd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.316 527.457h822.444V503.16H414.316v24.297",
    style: {
      fill: "#72a4dd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.715 532.598h822.445v-24.301H418.715v24.301",
    style: {
      fill: "#72a4dd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.105 537.715h822.445v-24.277H423.105v24.277",
    style: {
      fill: "#71a3dc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.504 542.867h822.446v-24.293H427.504v24.293",
    style: {
      fill: "#70a3dc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.902 547.992h822.448v-24.301H431.902v24.301",
    style: {
      fill: "#6fa2dc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.309 553.133h822.441v-24.301H436.309v24.301",
    style: {
      fill: "#6ea2dc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.699 558.262h822.441v-24.289H440.699v24.289",
    style: {
      fill: "#6da1db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.098 563.387h822.442v-24.285H445.098v24.285",
    style: {
      fill: "#6ca1db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.496 568.531h822.444v-24.293H449.496v24.293",
    style: {
      fill: "#6ba0db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.887 573.656h822.443v-24.285H453.887v24.285",
    style: {
      fill: "#6aa0db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.293 578.801h822.437v-24.305H458.293v24.305",
    style: {
      fill: "#699fdb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.691 583.926h822.439v-24.289H462.691v24.289",
    style: {
      fill: "#699fda",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.09 589.063h822.44v-24.297H467.09v24.297",
    style: {
      fill: "#689eda",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48 594.195h822.45v-24.293H471.48v24.293",
    style: {
      fill: "#679eda",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.883 599.32h822.447v-24.285H475.883v24.285",
    style: {
      fill: "#669dda",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.281 604.465h822.439v-24.293H480.281v24.293",
    style: {
      fill: "#659dda",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.672 609.59h822.448v-24.289H484.672v24.289",
    style: {
      fill: "#649cd9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.07 614.719h822.44V590.43H489.07v24.289",
    style: {
      fill: "#639cd9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.473 619.859h822.447V595.57H493.473v24.289",
    style: {
      fill: "#629bd9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.867 624.996h822.453v-24.297H497.867v24.297",
    style: {
      fill: "#619bd9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.266 630.129h822.444V605.84H502.266v24.289",
    style: {
      fill: "#609ad8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.664 635.254h822.446v-24.285H506.664v24.285",
    style: {
      fill: "#5f9ad8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.066 640.395h822.444v-24.293H511.066v24.293",
    style: {
      fill: "#5e99d8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.453 645.523H1337.9v-24.289H515.453v24.289",
    style: {
      fill: "#5d99d8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.859 650.652H1342.3v-24.289H519.859v24.289",
    style: {
      fill: "#5d98d8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.258 655.789H1346.7v-24.285H524.258v24.285",
    style: {
      fill: "#5c98d7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.648 660.926H1351.1v-24.293H528.648v24.293",
    style: {
      fill: "#5b98d7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.047 666.059h822.443v-24.301H533.047v24.301",
    style: {
      fill: "#5a97d7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.449 671.188h822.441v-24.29H537.449v24.29",
    style: {
      fill: "#5997d7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.852 676.328h822.438v-24.293H541.852v24.293",
    style: {
      fill: "#5896d7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.238 681.453h822.452v-24.285H546.238v24.285",
    style: {
      fill: "#5796d6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.641 686.594h822.449v-24.297H550.641v24.297",
    style: {
      fill: "#5695d6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.039 691.723h822.451v-24.285H555.039v24.285",
    style: {
      fill: "#5695d6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.434 696.859h822.446v-24.296H559.434v24.296",
    style: {
      fill: "#5594d6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.832 701.992h822.438v-24.289H563.832v24.289",
    style: {
      fill: "#5494d6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.234 707.117h822.436v-24.285H568.234v24.285",
    style: {
      fill: "#5394d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.633 712.262h822.447v-24.293H572.633v24.293",
    style: {
      fill: "#5293d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.023 717.387h822.447v-24.285H577.023v24.285",
    style: {
      fill: "#5193d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.426 722.527h822.444v-24.3H581.426v24.3",
    style: {
      fill: "#5092d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.824 727.656h822.446v-24.289H585.824v24.289",
    style: {
      fill: "#4f92d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.215 732.793h822.455v-24.297H590.215v24.297",
    style: {
      fill: "#4f91d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.613 737.926h822.457v-24.293H594.613v24.293",
    style: {
      fill: "#4e91d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.016 743.051h822.444v-24.285H599.016v24.285",
    style: {
      fill: "#4d91d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.418 748.191h822.442v-24.289H603.418v24.289",
    style: {
      fill: "#4c90d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.809 753.32h822.441v-24.289H607.809v24.289",
    style: {
      fill: "#4b90d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.207 758.445h822.443V734.16H612.207v24.285",
    style: {
      fill: "#4a8fd3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.605 763.59h822.445v-24.289H616.605v24.289",
    style: {
      fill: "#498fd3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.008 768.727h822.442V744.43H621.008v24.297",
    style: {
      fill: "#498ed3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.402 773.855h822.438v-24.289H625.402v24.289",
    style: {
      fill: "#488ed3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.801 778.984h822.439v-24.289H629.801v24.289",
    style: {
      fill: "#478ed3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.191 784.125h822.449v-24.293H634.191v24.293",
    style: {
      fill: "#468dd2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.59 789.254h822.46v-24.289H638.59v24.289",
    style: {
      fill: "#458dd2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.988 794.387h822.442v-24.293H642.988v24.293",
    style: {
      fill: "#448cd2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.395 799.52h822.435v-24.286H647.395v24.286",
    style: {
      fill: "#438cd2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.781 804.656h822.449v-24.297H651.781v24.297",
    style: {
      fill: "#428cd2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.184 809.789h822.436v-24.301H656.184v24.301",
    style: {
      fill: "#428bd1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.582 814.918h822.448v-24.289H660.582v24.289",
    style: {
      fill: "#418bd1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.98 820.059h822.45v-24.293H664.98v24.293",
    style: {
      fill: "#408ad1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.375 825.184h822.445v-24.286H669.375v24.286",
    style: {
      fill: "#3f8ad1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.773 830.32h822.447v-24.297H673.773v24.297",
    style: {
      fill: "#3e8ad1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.176 835.453h822.444V811.16H678.176v24.293",
    style: {
      fill: "#3d89d0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.582 840.605h822.448v-24.292H682.582v24.292",
    style: {
      fill: "#3d89d0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.988 845.73h822.442v-24.285H686.988v24.285",
    style: {
      fill: "#3c88d0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.379 850.867h822.441v-24.285H691.379v24.285",
    style: {
      fill: "#3b88d0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.777 856.012h822.443v-24.305H695.777v24.305",
    style: {
      fill: "#3a88d0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.176 861.137h822.444V836.84H700.176v24.297",
    style: {
      fill: "#3987cf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.566 866.27h822.454v-24.293H704.566v24.293",
    style: {
      fill: "#3887cf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.969 871.406h822.451v-24.289H708.969v24.289",
    style: {
      fill: "#3786cf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.367 876.531h822.443v-24.285H713.367v24.285",
    style: {
      fill: "#3786cf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.758 881.676h822.452v-24.305H717.758v24.305",
    style: {
      fill: "#3686cf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.156 886.801h822.454v-24.285H722.156v24.285",
    style: {
      fill: "#3585ce",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.563 891.941H1549v-24.3H726.563v24.3",
    style: {
      fill: "#3485ce",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.961 897.07H1553.4v-24.297H730.961v24.297",
    style: {
      fill: "#3384ce",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.352 902.203H1557.8V877.91H735.352v24.293",
    style: {
      fill: "#3284ce",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.75 907.34h822.45v-24.289H739.75v24.289",
    style: {
      fill: "#3284ce",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.152 912.465H1566.6V888.18H744.152v24.285",
    style: {
      fill: "#3183cd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.555 917.605H1571v-24.296H748.555v24.296",
    style: {
      fill: "#3083cd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.945 922.734h822.445v-24.289H752.945v24.289",
    style: {
      fill: "#2f83cd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.344 927.875H1579.8v-24.301H757.344v24.301",
    style: {
      fill: "#2e82cd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.742 933.004h822.448v-24.289H761.742v24.289",
    style: {
      fill: "#2d82cd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.133 938.137h822.457v-24.293H766.133v24.293",
    style: {
      fill: "#2c82cd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.535 943.27h822.445v-24.286H770.535v24.286",
    style: {
      fill: "#2c81cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.938 948.398h822.442v-24.289H774.938v24.289",
    style: {
      fill: "#2b81cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.336 953.539h822.444v-24.301H779.336v24.301",
    style: {
      fill: "#2a80cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.727 958.668h822.453v-24.289H783.727v24.289",
    style: {
      fill: "#2980cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.125 963.809h822.445v-24.301H788.125v24.301",
    style: {
      fill: "#2880cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.527 968.934h822.443v-24.286H792.527v24.286",
    style: {
      fill: "#287fcb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.918 974.063h822.452v-24.29H796.918v24.29",
    style: {
      fill: "#277fcb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.32 979.203h822.44v-24.285H801.32v24.285",
    style: {
      fill: "#267fcb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.719 984.332h822.441v-24.289H805.719v24.289",
    style: {
      fill: "#257ecb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.109 989.461h822.451v-24.285H810.109v24.285",
    style: {
      fill: "#247ecb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.512 994.598h822.448v-24.285H814.512v24.285",
    style: {
      fill: "#237eca",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.91 999.742h822.44v-24.304H818.91v24.304",
    style: {
      fill: "#237dca",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.313 1004.87h822.437v-24.3H823.313v24.3",
    style: {
      fill: "#227dca",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.699 1010h822.461v-24.293H827.699V1010",
    style: {
      fill: "#217dca",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.102 1015.14h822.448v-24.292H832.102v24.292",
    style: {
      fill: "#207cca",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.504 1020.26h822.446v-24.283H836.504v24.283",
    style: {
      fill: "#1f7cc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.902 1025.41h822.438v-24.31H840.902v24.31",
    style: {
      fill: "#1e7cc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.293 1030.53h822.447v-24.28H845.293v24.28",
    style: {
      fill: "#1e7bc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.691 1035.67h822.449v-24.3H849.691v24.3",
    style: {
      fill: "#1d7bc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.094 1040.8h822.446v-24.3H854.094v24.3",
    style: {
      fill: "#1c7bc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.484 1045.93h822.456v-24.29H858.484v24.29",
    style: {
      fill: "#1b7ac9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.887 1051.07h822.443v-24.29H862.887v24.29",
    style: {
      fill: "#1a7ac8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.285 1056.2h822.445v-24.29H867.285v24.29",
    style: {
      fill: "#1a7ac8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.676 1061.34h822.454v-24.3H871.676v24.3",
    style: {
      fill: "#1979c8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.074 1066.46h822.456v-24.28H876.074v24.28",
    style: {
      fill: "#1879c8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.48 1071.61h822.44v-24.31H880.48v24.31",
    style: {
      fill: "#1779c8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.879 1076.73h822.441v-24.28H884.879v24.28",
    style: {
      fill: "#1678c7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1567.61 525.027h-1.22l-69.29-240.855h141.63zm-34.33 53.176h71.73l144.08-451.691h-63.15l-31.88 107.609H1483l-33.1-107.609h-57.02l140.4 451.691M1922.01 442.445h50.28V192.207c0-21.906 1.23-43.801 3.06-65.695h-53.34v38.164h-1.83c-16.56-28.778-45.99-44.422-78.48-44.422-53.96 0-83.38 27.527-83.38 81.34v240.851h50.27V223.484c0-38.164 17.17-63.816 52.73-63.816 26.97 0 60.69 20.645 60.69 73.203v209.574M2122.52 406.785c-53.95 0-61.3-43.793-61.3-128.25 0-47.551 0-116.359 63.15-116.359 56.4 0 56.4 71.32 56.4 135.129 0 41.914-2.45 109.48-58.25 109.48zm58.25 171.418h50.28V126.512h-50.28v37.539h-1.22c-17.17-29.403-38.63-43.797-71.13-43.797-49.66 0-99.93 20.019-99.93 158.906 0 78.828 2.45 169.539 102.39 169.539 29.43 0 50.88-13.133 68.05-38.156h1.84v167.66M2310.16 220.352c0-30.657 14.71-58.176 48.43-58.176 30.66 0 68.68 19.394 63.76 121.363-47.82-.625-112.19 3.758-112.19-63.187zm113.42-48.164h-1.23c-15.32-36.29-39.23-51.934-77.86-51.934-65.6 0-84.6 43.172-84.6 103.855 0 95.719 91.96 100.098 162.46 98.219 1.23 41.918 1.85 87.59-52.11 87.59-33.72 0-51.49-23.152-48.43-56.309h-54.57c2.46 70.696 39.24 95.09 104.84 95.09 79.71 0 100.55-41.914 100.55-95.09V201.594c0-25.031 2.45-50.688 6.13-75.082h-55.18v45.676M2748.55 126.512h-66.21l-71.72 129.504-66.84-129.504h-59.46l96.25 165.164-88.28 150.769h64.37l58.86-113.238 62.54 113.238h60.69l-92.58-150.769 102.38-165.164",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 140.853)"
  }));
};
export default SvgHeaderLogo;